<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('skillZone.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_skill_zone')"
                :title="$addLabel('skill_zone')"
                @click="openSkillZoneModal()"
            />
        </app-page-top-section>

        <app-table
            id="skill-zone-table"
            :options="options"
            @action="triggerActions"
        />

        <app-skill-zone-modal
            v-if="isSkillZoneModalActive"
            v-model="isSkillZoneModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('skill-zone-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import skillZoneMixin from "../../../Mixins/Recruitment/SkillZoneMixin";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "SkillZone",
    mixins: [skillZoneMixin],
    data() {
        return {
            skillZone: '',
            skillZoneId: '',
            skillZones: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            title: '',
            description: '',
            passing_score: '',
            isSkillZoneModalActive: false,
            confirmationModalActive: false,
            isEmployeeMovementModalActive: false,
        }
    },
    watch: {
        isSkillZoneModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openSkillZoneModal() {
            this.selectedUrl = '';
            this.isSkillZoneModalActive = true;
        },
        triggerActions(row, action, active) {
            this.skillZoneId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isSkillZoneModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
